<template>
  <layout>
    <div slot="content">
      <i-card title="用户组列表">
        <div slot="content">
          <el-table :data="adminGroupList" :border="true">
            <el-table-column prop="id" label="用户组id"></el-table-column>
            <el-table-column prop="name" label="用户组名称"></el-table-column>
            <el-table-column prop="real_name" label="操作" width="300px">
              <div slot-scope="scope">
                <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                <el-button size="mini" type="primary" @click="openPutPrivilege(scope.row)">权限分配</el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <el-button type="success" size="medium" icon="el-icon-plus" @click="showAddGroup=true">
            添加用户组
          </el-button>
        </div>
      </i-card>
      <el-dialog :visible.sync="showAddGroup" title="添加用户组" width="450px">
        <el-form :model="currGroup" size="small" :rules="validateRules" label-width="95px">
          <el-form-item label="管理组名称" prop="name">
            <el-input v-model="currGroup.name"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showAddGroup = false">取消</el-button>
          <el-button type="primary" :loading="loading" @click="addGroup">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="privilege.show" title="编辑权限点" width="600px">
        <el-form :model="currGroup" size="small"  label-width="95px">
          <el-form-item label="管理组名称:" prop="name">
            {{currGroup.name}}
          </el-form-item>
          <el-form-item label="权限点" prop="privilege_ids">
            <el-checkbox-group v-model="privilege.checked_privilege">

              <el-checkbox v-for="(privilege,idx) in privilege.all_privilege_list" :label="privilege.privilege_id" :value="privilege.privilege_id" :key="idx">{{ privilege.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="privilege.show = false">取消</el-button>
          <el-button type="primary" :loading="loading" @click="putPrivileges">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "admin_group",
  data: function () {
    return {
      adminGroupList: [],
      showAddGroup: false,
      groups: [],
      validateRules: {
        name: [
          {required: true, message: '请输入用户组名称', trigger: 'blur'},
        ],
      },
      currGroup: {
        name: '',
        id: ''
      },
      privilege: {
        show:false,
        all_privilege_list: [],
        checked_privilege :[]
      },
      loading: false
    }
  },
  methods: {
    getGroupList: function () {
      this.$http.request('AdminGroupList').then(res => {
        this.adminGroupList = res.data;
      });
    },
    addGroup: function () {
      this.loading = true;
      this.$http.request('postAdminGroup', this.currGroup).then(res => {
        this.loading = false;
        if (res.status === 'success') {
          this.$message({message: res.message, type: 'success'});
          this.showAddGroup = false;
          this.currGroup = {
            name: '',
            id: ''
          };
          this.getGroupList();
        }
      });
    },
    edit: function (group) {
      this.showAddGroup = true;
      this.currGroup = {
        name: group.name,
        id: group.id
      };
    },
    openPutPrivilege:function (group){
      this.privilege.show = true;
      this.currGroup = {
        name: group.name,
        id: group.id
      };
      this.privilege.checked_privilege = [];
      let _self = this;
      this.$http.request('getPrivilegeList',{group_id:group.id}).then(res=>{
        _self.loading = false;
        if(res.status === 'success'){
          _self.privilege.all_privilege_list = res.data.all_privilege_list;
          res.data.has_privilege_list.forEach(row=>{
            _self.privilege.checked_privilege.push(row.privilege_id);
          })
        }
      });
    },
    putPrivileges:function (){
      this.loading = true;
      this.$http.request('putGroupPrivilege',{group_id:this.currGroup.id,privilege_ids:this.privilege.checked_privilege}).then(res=>{
        if(res.status ==='success'){
          this.loading = false;
          this.getGroupList();
          this.privilege.show = false;
        }
      })
    }
  },
  created: function () {
    this.getGroupList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/admin/admin_group.vue